"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _pdp_header = require("./pdp_header");

var _pdp_header2 = _interopRequireDefault(_pdp_header);

var _pdp_sticky_header = require("./pdp_sticky_header");

var _pdp_sticky_header2 = _interopRequireDefault(_pdp_sticky_header);

var _constants = require("../../../packages/common-utilities/src/constants");

var _constants2 = _interopRequireDefault(_constants);

var _ramda = require("ramda");

var _cms_utility = require("../../../packages/common-utilities/src/cms_utility");

var _jump_to_funds_app = require("./jump_to_funds_app");

var _jump_to_funds_app2 = _interopRequireDefault(_jump_to_funds_app);

var _shareclass_selector = require("./shareclass_selector");

var _shareclass_selector2 = _interopRequireDefault(_shareclass_selector);

var _string_utility = require("../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _collection_utility = require("common-utilities/src/collection_utility");

var _product_selector_app = require("./product_selector_app");

var _product_selector_app2 = _interopRequireDefault(_product_selector_app);

var _sanitize_utility = require("../../../packages/common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _tracking_utility = require("../../../packages/common-utilities/src/tracking_utility");

var _button = require("./global_components/button");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PdpSummary = function (_React$Component) {
  _inherits(PdpSummary, _React$Component);

  function PdpSummary(props) {
    _classCallCheck(this, PdpSummary);

    var _this = _possibleConstructorReturn(this, (PdpSummary.__proto__ || Object.getPrototypeOf(PdpSummary)).call(this, props));

    _this.state = {};
    _this.stickyHeaderRef = '';
    _this.renderSummaryAlerts = _this.renderSummaryAlerts.bind(_this);
    _this.renderJumpToFundApp = _this.renderJumpToFundApp.bind(_this);
    _this.hasShareClassSelector = _this.hasShareClassSelector.bind(_this);
    _this.renderAlert = _this.renderAlert.bind(_this);
    return _this;
  }

  _createClass(PdpSummary, [{
    key: "getIconEl",
    value: function getIconEl(tooltipId) {
      return document.getElementById("disclosure-" + tooltipId);
    }
  }, {
    key: "renderAlert",
    value: function renderAlert(alertMessage, alertType, fundAlert, isSticky) {
      var ctaUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      var isCustomAlert = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      var alertTypeId = alertType.replace(/\s+/g, '').toUpperCase();
      var widthPercent = isCustomAlert ? "" : "width-percent-66";
      return _react2.default.createElement(
        "div",
        { key: alertTypeId, id: "disclosure-parent-" + (isSticky ? "sticky-" : "") + alertTypeId,
          className: "" + (this.props.breakpoint < 3 ? "display-block margin-bottom-5" : "alert-item-wrapper padding-vertical-13") },
        _react2.default.createElement(
          "div",
          { "data-testid": "alert-type", className: "tag " + (this.props.breakpoint < 3 ? "" : "padding-horizontal-20 alert-pipe") },
          _string_utility2.default.renderFormattedLabel(alertType, alertType.replace(/ /g, '-').toUpperCase() + "-chip")
        ),
        _react2.default.createElement("div", { "data-testid": "alert-description", className: "category padding-vertical-5 " + (this.props.breakpoint < 3 ? "" : "padding-horizontal-20 " + widthPercent), dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(alertMessage) } }),
        !(0, _functional_utility.isNilOrEmpty)(ctaUrl) && _react2.default.createElement(_button2.default, {
          additionalClassName: "slide-button margin-horizontal-10 back",
          downloadURL: ctaUrl,
          dataTestLink: "cta-link-more-info",
          dataTest: "cta-link-button-more-info",
          text: _string_utility2.default.renderFormattedLabel("More Info", "pdp-summary-header-alert-more-info"),
          openInNewTab: ctaUrl.startsWith("http") ? true : false,
          buttonType: "moreInfoButtonCTA",
          breakpoint: this.props.breakpoint,
          callBack: function callBack() {
            return _tracking_utility.TrackingUtility.trackEvent({
              "eventCategory": 'button',
              "eventAction": "More Info",
              "eventLabel": ctaUrl
            });
          }
        })
      );
    }
  }, {
    key: "renderBrandImage",
    value: function renderBrandImage(dataTest) {
      var _props = this.props,
          fund = _props.fund,
          breakpoint = _props.breakpoint,
          gaiaRedirectUrl = _props.gaiaRedirectUrl;

      if ((0, _ramda.isNil)(fund.shareClass.brandImageURL)) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { className: "display-inline-block", style: { 'verticalAlign': 'text-bottom' } },
        _react2.default.createElement("img", {
          className: "float-left margin-right-10 " + (0, _functional_utility.ifMobileBreakpoint)(breakpoint, 'padding-bottom-10', ''),
          "data-testid": "brand-image-url-" + dataTest,
          src: gaiaRedirectUrl + fund.shareClass.brandImageURL,
          width: "120" })
      );
    }
  }, {
    key: "hasShareClassSelector",
    value: function hasShareClassSelector() {
      var isVisible = false;
      if ((0, _ramda.and)(!_collection_utility.CollectionUtility.includes(_constants2.default.getExcludeRolesShareclassSelectorConstants(), this.props.role), !(0, _functional_utility.doesVisibleDataPointContains)("HIDE_SHARECLASS_SELECTOR", this.props) && !(0, _functional_utility.isDataEmpty)(this.props.fund.shareclassOptionList))) {
        isVisible = true;
      }
      return isVisible;
    }
  }, {
    key: "showShareclassSelector",
    value: function showShareclassSelector(isStickyHeaderVisible) {
      if (this.hasShareClassSelector()) {
        return _react2.default.createElement(_shareclass_selector2.default, {
          pdpPath: this.props.pdpPath,
          parent: this.props.parent,
          basePath: this.props.basePath,
          options: this.props.fund.shareclassOptionList,
          cusip: this.props.cusip,
          fundName: this.props.fund.name,
          breakpoint: this.props.breakpoint,
          shareClass: this.props.fund.shareClass.categoryCode,
          shareClassDisplayName: this.props.fund.shareClass.displayName,
          isStickyHeaderVisible: isStickyHeaderVisible,
          country: this.props.country,
          visibleData: this.props.fund.visibleData.visibleDataPoints
        });
      }
      return null;
    }
  }, {
    key: "renderDashShareclass",
    value: function renderDashShareclass() {
      var fund = this.props.fund;

      if ((0, _ramda.isNil)(fund.shareClass.categoryCode) || fund.shareClass.categoryCode === "ETF Shares") {
        return null;
      }

      return _react2.default.createElement(
        "span",
        { "data-testid": "dash-fund-shareclass", className: "print-display print-display-inline",
          style: { "display": "none" } },
        "\u2013 ",
        fund.shareClass.categoryCode
      );
    }
  }, {
    key: "renderFundNameDisclosure",
    value: function renderFundNameDisclosure() {
      var fund = this.props.fund;

      if (_collection_utility.CollectionUtility.includes(fund.visibleData.visibleDataPoints, 'SHOW_FUND_NAME_DISCLOSURE')) {
        return _react2.default.createElement(
          "span",
          { "data-testid": "fund-name-disclosure", className: "font-bold" },
          "\xA0",
          fund.disclosures['FundNameDisclosure']
        );
      }
    }
  }, {
    key: "renderSummaryAlerts",
    value: function renderSummaryAlerts(isSticky) {
      var _this2 = this;

      var cusipOrIsinUpperCase = (0, _functional_utility.toUpperOrEmptyString)(this.props.cusip);
      var fundContentAndAlertNotEmpty = function fundContentAndAlertNotEmpty(key) {
        if ((0, _cms_utility.isAEM)(_this2.props)) {
          return (0, _ramda.pathOr)(false, ["content", "alerts", cusipOrIsinUpperCase, key], _this2.props);
        }

        if (!(0, _functional_utility.isDataEmpty)(_this2.props.fund.fundContent)) {
          var _alerts = _this2.props.fund.fundContent.alerts;

          return !(0, _functional_utility.isDataEmpty)(_alerts) && !(0, _functional_utility.isDataEmpty)(_alerts[key]);
        }
        return false;
      };

      var fundAlertNotEmpty = function fundAlertNotEmpty(key) {
        if (!(0, _functional_utility.isDataEmpty)(_this2.props.fund)) {
          var _alerts2 = _this2.props.fund.alerts;

          return !(0, _functional_utility.isDataEmpty)(_alerts2) && !(0, _functional_utility.isDataEmpty)(_alerts2[key]);
        }

        if ((0, _cms_utility.isAEM)(_this2.props)) {
          return (0, _ramda.pathOr)(false, ["content", "alerts", cusipOrIsinUpperCase, key], _this2.props);
        }
        return false;
      };

      var statusBasedAlerts = ["fund", "alerts"];
      var alertClosedToShareholdersMessage = (0, _functional_utility.pathOrNull)([].concat(statusBasedAlerts, ["alertClosedToShareholdersMessage"]), this.props);
      var alertLimitedOffering = (0, _functional_utility.pathOrNull)([].concat(statusBasedAlerts, ["alertLimitedOffering"]), this.props);
      var alertHardLiquidated = (0, _functional_utility.pathOrNull)([].concat(statusBasedAlerts, ["alertHardLiquidated"]), this.props);
      var alertSoftClosedMerged = (0, _functional_utility.pathOrNull)([].concat(statusBasedAlerts, ["alertSoftClosedMerged"]), this.props);

      var alertsBasePath = ["fund", "fundContent", "alerts"];
      if ((0, _cms_utility.isAEM)(this.props)) {
        alertsBasePath = ["content", "alerts", cusipOrIsinUpperCase];
      }
      var alertMergedMessage = (0, _functional_utility.pathOrNull)([].concat(_toConsumableArray(alertsBasePath), ["alertMergedMessage"]), this.props);
      var alertRenamedMessage = (0, _functional_utility.pathOrNull)([].concat(_toConsumableArray(alertsBasePath), ["alertRenamedMessage"]), this.props);
      var alertEstimatedCapitalGainsMessage = (0, _functional_utility.pathOrNull)([].concat(_toConsumableArray(alertsBasePath), ["alertEstimatedCapitalGainsMessage"]), this.props);
      var alertPortfolioManagerUpdateMessage = (0, _functional_utility.pathOrNull)([].concat(_toConsumableArray(alertsBasePath), ["alertPortfolioManagerUpdateMessage"]), this.props);
      var alertNoticeMessage = (0, _functional_utility.pathOrNull)([].concat(_toConsumableArray(alertsBasePath), ["alertNoticeMessage"]), this.props);
      var alertETFAvailable = (0, _functional_utility.pathOrNull)([].concat(_toConsumableArray(alertsBasePath), ["alertETFAvailable"]), this.props);
      var alertinliquidation = (0, _functional_utility.pathOrNull)([].concat(_toConsumableArray(alertsBasePath), ["alertinliquidation"]), this.props);
      var alertCustomMessage = (0, _functional_utility.pathOrNull)([].concat(_toConsumableArray(alertsBasePath), ["alertCustomMessage"]), this.props);

      var alertSubContent = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'SHOW_ALERTS_SUBCONTENT') ? _constants2.default.getFundAlert() : null;

      var alerts = [];
      if (fundAlertNotEmpty("alertClosedToShareholdersMessage")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertClosedToShareholdersMessage), _constants2.default.getAlertsName('alertClosedToShareholdersMessage'), alertSubContent, isSticky));
      }
      if (fundAlertNotEmpty("alertLimitedOffering")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertLimitedOffering), _constants2.default.getAlertsName('alertLimitedOffering'), alertSubContent, isSticky));
      }
      if (fundAlertNotEmpty("alertHardLiquidated")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertHardLiquidated), _constants2.default.getAlertsName('alertHardLiquidated'), alertSubContent, isSticky));
      }
      if (fundAlertNotEmpty("alertSoftClosedMerged")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertSoftClosedMerged), _constants2.default.getAlertsName('alertSoftClosedMerged'), alertSubContent, isSticky));
      }
      if (fundContentAndAlertNotEmpty("alertNoticeMessage")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertNoticeMessage), _constants2.default.getAlertsName('alertNoticeMessage'), '', isSticky));
      }
      if (fundContentAndAlertNotEmpty("alertMergedMessage")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertMergedMessage), _constants2.default.getAlertsName('alertMergedMessage'), '', isSticky));
      }
      if (fundContentAndAlertNotEmpty("alertRenamedMessage")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertRenamedMessage), _constants2.default.getAlertsName('alertRenamedMessage'), '', isSticky));
      }
      if (fundContentAndAlertNotEmpty("alertETFAvailable")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertETFAvailable), _constants2.default.getAlertsName('alertETFAvailable'), '', isSticky));
      }
      if (fundContentAndAlertNotEmpty("alertEstimatedCapitalGainsMessage")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertEstimatedCapitalGainsMessage), _constants2.default.getAlertsName('alertEstimatedCapitalGainsMessage'), '', isSticky));
      }
      if (fundContentAndAlertNotEmpty("alertPortfolioManagerUpdateMessage")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertPortfolioManagerUpdateMessage), _constants2.default.getAlertsName('alertPortfolioManagerUpdateMessage'), '', isSticky));
      }
      if (fundContentAndAlertNotEmpty("alertinliquidation")) {
        alerts.push(this.renderAlert(this.getAlertContentOrString(alertinliquidation), _constants2.default.getAlertsName('alertinliquidation'), '', isSticky));
      }
      if (fundContentAndAlertNotEmpty("alertCustomMessage")) {
        alerts.push(this.renderAlert(alertCustomMessage.alertContent, alertCustomMessage.alertTitle, '', isSticky, alertCustomMessage.alertMoreInfo, true));
      }

      if ((0, _ramda.isEmpty)(alerts)) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: "alert-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "container alert-container " + (this.props.breakpoint < 3 ? "padding-horizontal-0" : "padding-horizontal-30") },
          alerts
        )
      );
    }
  }, {
    key: "getAlertContentOrString",
    value: function getAlertContentOrString(alertObj) {
      return (0, _functional_utility.isNilOrEmpty)(alertObj.alertContent) ? alertObj : alertObj.alertContent;
    }
  }, {
    key: "setAdditionalRating",
    value: function setAdditionalRating(rating) {
      this.setState({ additionalRatings: rating });
    }
  }, {
    key: "renderJumpToFundApp",
    value: function renderJumpToFundApp(additionalProps) {
      if ((0, _functional_utility.doesVisibleDataPointContains)('HIDE_JUMP_TO_FUNDS', this.props)) {
        return null;
      }
      if ((0, _functional_utility.doesVisibleDataPointContains)('SHOW_PRODUCT_DETAIL_DROPDOWN', this.props)) {
        return _react2.default.createElement(_product_selector_app2.default, _extends({
          pdpPath: this.props.pdpPath,
          parent: this.props.parent,
          basePath: this.props.basePath,
          window: this.props.window,
          options: this.props.autocompleteFundData,
          breakpoint: this.props.breakpoint,
          language: this.props.language
        }, additionalProps));
      }
      var showShareClassName = void 0;
      if ((0, _functional_utility.isMobileBreakpoint)(this.props.breakpoint)) {
        showShareClassName = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'JUMP_TO_FUNDS_SHOW_SHARECLASS_NAME_FOR_MOBILE');
      } else {
        showShareClassName = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'JUMP_TO_FUNDS_SHOW_SHARECLASS_NAME_FOR_DESKTOP');
      }
      return _react2.default.createElement(_jump_to_funds_app2.default, _extends({
        role: this.props.role,
        country: this.props.country,
        basePath: this.props.basePath,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        window: this.props.window,
        userLoggedIn: this.props.userLoggedIn,
        breakpoint: this.props.breakpoint,
        appType: this.props.appType,
        autocompleteFundData: this.props.autocompleteFundData,
        language: this.props.language,
        shouldShowCategory: _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'JUMP_TO_FUNDS_SHOW_CATEGORY'),
        showShareClassName: showShareClassName,
        parent: this.props.parent,
        pdpPath: this.props.pdpPath,
        tooltip: this.props.tooltip
      }, additionalProps));
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "print-min-height-disable" },
        this.renderHeader(),
        this.renderStickyHeader()
      );
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this3 = this;

      return _react2.default.createElement(
        "div",
        { "data-testid": "regular-header-div-test", className: "regular-header" },
        _react2.default.createElement(_pdp_header2.default, {
          renderSummaryAlerts: this.renderSummaryAlerts,
          additionalRatings: this.state.additionalRatings,
          setAdditionalRating: this.setAdditionalRating,
          renderJumpToFundApp: this.renderJumpToFundApp,
          breakpoint: this.props.breakpoint,
          tooltip: this.props.tooltip,
          isTabOrMobileBP: _functional_utility2.default.isTabOrMobileBreakpoint(this.props.breakpoint, "hide", ""),
          tabProps: this.props.tabProps,
          listOfAllTabs: this.props.listOfAllTabs,
          updateTabState: this.props.updateTabState,
          summaryHeaderBackgroundColor: PdpSummary.getSummaryHeaderBackgroundColor(this.props.role),
          renderBrandImage: function renderBrandImage(dataTest) {
            return _this3.renderBrandImage(dataTest);
          },
          hasShareClassSelector: this.hasShareClassSelector,
          showShareclassSelector: function showShareclassSelector(data) {
            return _this3.showShareclassSelector(data);
          },
          renderDashShareclass: function renderDashShareclass() {
            return _this3.renderDashShareclass();
          },
          renderFundNameDisclosure: function renderFundNameDisclosure() {
            return _this3.renderFundNameDisclosure();
          },
          fund: this.props.fund,
          content: this.props.content,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          window: this.props.window,
          getIconEl: this.getIconEl,
          cusip: this.props.cusip,
          role: this.props.role,
          country: this.props.country,
          basePath: this.props.basePath,
          userLoggedIn: this.props.userLoggedIn,
          language: this.props.language,
          additionalRatingsHandler: this.props.additionalRatingsHandler,
          isAEM: (0, _cms_utility.isAEM)(this.props),
          historicalData: this.props.historicalData,
          icData: this.props.icData,
          icMessageStatus: this.props.icMessageStatus,
          numberFormat: this.props.fund.numberFormat,
          intl: this.props.intl,
          cmsHost: this.props.fund.cmsHost
        })
      );
    }
  }, {
    key: "renderStickyHeader",
    value: function renderStickyHeader() {
      var _this4 = this;

      if (this.props.breakpoint > 3) {
        return _react2.default.createElement(
          "div",
          { ref: function ref(el) {
              return _this4.stickyHeaderRef = el;
            }, className: "hide print-disable-sticky",
            "data-testid": "sticky-header-div-test" },
          _react2.default.createElement(_pdp_sticky_header2.default, {
            renderSummaryAlerts: this.renderSummaryAlerts,
            renderJumpToFundApp: this.renderJumpToFundApp,
            breakpoint: this.props.breakpoint,
            renderBrandImage: function renderBrandImage(dataTest) {
              return _this4.renderBrandImage(dataTest);
            },
            hasShareClassSelector: this.hasShareClassSelector,
            showShareclassSelector: function showShareclassSelector(data) {
              return _this4.showShareclassSelector(data);
            },
            renderDashShareclass: function renderDashShareclass() {
              return _this4.renderDashShareclass();
            },
            renderFundNameDisclosure: function renderFundNameDisclosure() {
              return _this4.renderFundNameDisclosure();
            },
            tabProps: this.props.tabProps,
            listOfAllTabs: this.props.listOfAllTabs,
            updateTabState: this.props.updateTabState,
            fund: this.props.fund,
            content: this.props.content,
            gaiaRedirectUrl: this.props.gaiaRedirectUrl,
            summaryHeaderBackgroundColor: PdpSummary.getSummaryHeaderBackgroundColor(this.props.role) })
        );
      } else {
        return null;
      }
    }
  }], [{
    key: "getSummaryHeaderBackgroundColor",
    value: function getSummaryHeaderBackgroundColor(role) {
      if (role === '6c') {
        return "background-slate-grey-2";
      } else {
        return "background-pale-grey-two";
      }
    }
  }]);

  return PdpSummary;
}(_react2.default.Component);

exports.default = PdpSummary;